export class TaskOrder {
  id: number;
  ordervalue: number;
  orderdelivered: number;
  balancevalue: number;
  percentage: number;
  orderpaid: number;
}


